module.exports = __webpack_public_path__ + "img/11-1_06.162d6051.jpg";